import React, { useEffect, useState } from "react"
import { Modal, Form, Input, Button, } from "antd"
import { connect } from "react-redux"
import { MainActions, AuthActions } from "redux-store/models"


const EditListinoModal = ({
  visible,
  selectedListino,
  categories,
  onClose,
  form,
  updateListino,
}) => {
  const { getFieldDecorator, validateFields, setFieldsValue } = form
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (selectedListino) {
      setFieldsValue({
        name: selectedListino.name,
        description: selectedListino.description,
      })
    }
  }, [selectedListino, setFieldsValue])

  const handleSubmit = () => {
    validateFields((err, values) => {
      if (!err) {
        updateListino(
          values.name,
          selectedListino.status,
          values.description,
          selectedListino.id,
          setLoading,
          onClose
        )
      }
    })
  }

  return (
    <Modal
      className="add-service-modal"
      title="Edit Listino"
      visible={visible}
      onCancel={onClose}
      width={500}
      footer={
        <Button type="primary" block onClick={handleSubmit} loading={loading}>
          Update Listino
        </Button>
      }
    >
      {selectedListino && (
        <Form layout="vertical" className="add-service-form">
          <Form.Item label="Nome Listino">
            {getFieldDecorator("name", {
              rules: [
                {
                  required: true,
                  message: "Please enter the Listino name!",
                },
              ],
            })(<Input />)}
          </Form.Item>

          <Form.Item label="Note">
            {getFieldDecorator("description", {
              rules: [
                {
                  required: false,
                  message: "Inserisci una descrizione se necessario",
                },
              ],
            })(
              <Input.TextArea
                className="input-textarea"
                placeholder="Inserisci descrizione o note"
                rows={5}
              />
            )}
          </Form.Item>
        </Form>
      )}
    </Modal>
  )
}

const EditListinoForm = Form.create()(EditListinoModal)

const mapsStateToProps = ({ auth }) => ({})

export default connect(mapsStateToProps, { ...MainActions, ...AuthActions })(
  EditListinoForm
)
